import { ScrollArea, ScrollBar } from '@/components/ui/scroll-area';
import { Button } from '@/components/ui/button';
import { MapPin } from 'lucide-react';

export const NeighborhoodFilter = ({ neighborhoods, selected, onSelect }) => {
  return (
    <div className="p-2" data-testid="neighborhood-filter">
      <ScrollArea className="w-full">
        <div className="flex gap-2 pb-2">
          <Button
            variant={selected === null ? "default" : "ghost"}
            size="sm"
            onClick={() => onSelect(null)}
            className={`rounded-full whitespace-nowrap text-xs font-medium neighborhood-pill ${
              selected === null 
                ? 'bg-primary text-primary-foreground' 
                : 'hover:bg-muted'
            }`}
            data-testid="filter-all"
          >
            <MapPin className="w-3 h-3 mr-1.5" />
            All Brooklyn
          </Button>
          
          {neighborhoods.map((hood) => (
            <Button
              key={hood}
              variant={selected === hood ? "default" : "ghost"}
              size="sm"
              onClick={() => onSelect(hood)}
              className={`rounded-full whitespace-nowrap text-xs font-medium neighborhood-pill ${
                selected === hood 
                  ? 'bg-primary text-primary-foreground' 
                  : 'hover:bg-muted'
              }`}
              data-testid={`filter-${hood.toLowerCase().replace(/\s+/g, '-')}`}
            >
              {hood}
            </Button>
          ))}
        </div>
        <ScrollBar orientation="horizontal" className="h-1.5" />
      </ScrollArea>
    </div>
  );
};
